import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Categories from "../components/Categories";
import PromoBanners from "../components/PromoBanners";
import FeaturedProducts from "../components/FeaturedProducts";
import BrandHighlights from "../components/BrandHighlights";
import { useSeo } from "../lib/seo";
import Reviews from "../components/Reviews";
import Newsletter from "../components/Newsletter";
import InstagramSection from "../components/InstagramSection";

export default function Home() {
  useSeo({
    title: "Sparkwear | Children's Clothing Online UK — Where Kids Shine",
    description:
      "Children's clothing online UK: kids' school bags, children's socks, kids' underwear, baby clothes and children's leggings — pastel-perfect, play-proof, sizes 0–10Y.",
  });
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Categories />
      <FeaturedProducts />
      <PromoBanners />
      <BrandHighlights />
      <Reviews />
      <InstagramSection />
      <Newsletter />
    </main>
  );
}
